<template>
	<v-app style='background:transparent !important'>
		<icons />
		<router-view :key="$route.path + num"></router-view>
		<install-prompt />
	</v-app>
</template>

<style>
.login-semi-1 {
	background-color: rgba(0, 0, 0, 0.8);
}

.login-semi-2 {
	background-color: rgba(0, 0, 0, 0.6);
}

.login-semi-3 {
	background-color: rgba(0, 0, 0, 0.4);
}

.v-list-item.primary--text.v-list-item--active.v-list-item--link.theme--light {
	color: inherit !important;
	caret-color: inherit !important;
}

html,
body {
	overflow-y: auto !important;
}

.no-padding {
	padding: 0 !important;
}

.upper {
	text-transform: uppercase;
}

.f-400 {
	font-weight: 400;
}

.f-600 {
	font-weight: 600;
}

.v-card__title {
	font-size: 1.1rem;
	font-weight: 400;
	word-break: break-all;
}

.v-application {
	line-height: 1.3;
}

.v-application .red {
	background-color: #f8192c !important;
	border-color: #f8192c !important;
}

.kpi-1 {
	font-size: 0.85em;
}

.kpi-1 .v-icon {
	font-size: 2.8em !important;
	vertical-align: top !important;
}

.kpi-1 .v-card__text h3,
.kpi-1 .v-card__text h4 {
	width: auto;
}

.nowrap {
	white-space: nowrap;
}

.whitespace-pre-wrap {
	white-space: pre-wrap;
}

.upper {
	text-transform: uppercase;
}

/* esto afecta a los gráficos de dona */
.v-application {
	font-family: 'Poppins', 'Roboto', sans-serif !important;
}

.v-application h2 {
	font-weight: 500;
}

svg text {
	font-family: Poppins, Roboto, sans-serif !important;
}

.apexcharts-datalabels-group text {
	text-transform: uppercase;
}

/* esto afecta a los gráfico de area/líneas/barras */
.apexcharts-canvas .apexcharts-zoom-icon.apexcharts-selected svg {
	fill: #f64e60;
}

/* === Date picker fixes (global) ===
   Vuetify pins .v-date-picker-table to height:242px which clips the last
   row on 5–6 week months. Force everything to grow with content and put a
   visible separator above the action bar so day numbers never land on
   Cancelar/Aceptar. */
.v-date-picker-table {
  height: auto !important;
  min-height: 242px !important;
  overflow: visible !important;
}
.v-picker__body {
  overflow: visible !important;
  height: auto !important;
  padding-bottom: 16px !important;
}
/* Push the action bar well below the day grid — high specificity to win. */
.v-application .v-date-picker .v-card__actions,
.v-application .v-picker > .v-card__actions {
  margin-top: 36px !important;
  border-top: 1px solid rgba(0,0,0,.08) !important;
  padding: 10px 14px !important;
  background: #fff;
  position: relative;
  z-index: 2;
}
</style>
<script>
import WhatsAppFab from "./components/WhatsAppFab.vue";
import Icons from './components/Icons'
import InstallPrompt from "./components/InstallPrompt.vue";
//import IconsTwo from './components/IconsWidget'

export default {
	components: {
		WhatsAppFab,
		Icons,
		InstallPrompt
	},
	data() {
		this.vars = {
			num: 0
		}
		window.forceRender = () => {
			this.vars.num++
		}
		return this.vars
	}
}
</script>
